import { render } from "./EevntSummaryReport.vue?vue&type=template&id=1c972cb4&scoped=true"
import script from "./EevntSummaryReport.vue?vue&type=script&lang=js"
export * from "./EevntSummaryReport.vue?vue&type=script&lang=js"

import "./EevntSummaryReport.vue?vue&type=style&index=0&id=1c972cb4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c972cb4"]])

export default __exports__